import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import store from './store';
import history from './store/history';
import App from './App';
import axios from 'axios';
import { notFound } from './actions/4xx';
import { doUnauthorized } from './actions/login';
import { ThemeProvider } from '@mui/material/styles';
import theme from './app/theme';
import { SnackbarProvider } from 'notistack';

const { dispatch } = store;

axios.defaults.baseURL = process.env.PUBLIC_URL;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  async (req) => {
    if (['post', 'patch', 'put', 'delete'].includes(req?.method?.toLowerCase())) {
      let csrfUrl = `/csrf`;
      let res = await axios.get(csrfUrl);
      req.headers[res.data['headerName']] = res.data.token;
    }
    return req;
  },
  (error) => Promise.reject(error)
);
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if ([401, 403].includes(status)) {
      dispatch(doUnauthorized(error));
    } else if ([404].includes(status)) {
      dispatch(notFound());
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <SnackbarProvider maxSnack={3}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    </SnackbarProvider>
  </ThemeProvider>,
  document.getElementById('root')
);
